// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q49FZ","content":"styles_content__2GIHi","tableWrap":"styles_tableWrap__3B9oV"};